module.exports = __webpack_public_path__ + "static/button-hear--large-a0c21a38e405b9af2b52185d07c5561e.svg";